import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14.17 1L7 8.18V21h12.31L23 12.4V8h-8.31l1.12-5.38zM1 9h4v12H1z"
}), 'ThumbUpAltSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ThumbUpAltSharp.js
// module id = 6788
// module chunks = 2